import { Component, Input, OnInit } from '@angular/core';

import { AssignmentParticipantRegistrationDetailModel } from '../../../models/assignment-participants/assignment-participant-registration-detail.model';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    templateUrl: './assignment-participant-registration-details-modal.component.html',
    styleUrl: './assignment-participant-registration-details-modal.component.scss'
})
export class AssignmentParticipantRegistrationDetailsModalComponent implements OnInit {
    @Input({ required: true }) registrationDetails!: AssignmentParticipantRegistrationDetailModel[];
    @Input({ required: true }) personFullName!: string;

    protected title!: string;

    constructor(
        private translocoService: TranslocoService
    ) { }

    ngOnInit(): void {
        let title = this.translocoService.translate('assignments.participants.registrationDetails.title');
        title = `${this.personFullName} - ${title}`
        this.title = title;
    }
}
